<div class="snackbar-{{data.type}}">
    {{data.message}}
</div>
<button (click)="dismiss()">
  <mat-icon class="clear-icon">clear</mat-icon>
</button>
  